import React from 'react';

import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import st from './BaseDataItem.module.sass';

export interface BaseDataItemProps extends WithDataTestid, WithClassNameProp {
  title: React.ReactNode;
  actions?: React.ReactNode;
}

export function BaseDataItem({
  title,
  actions = undefined,
  className = undefined,
  'data-testid': dataTestId = 'data-item',
}: BaseDataItemProps): JSX.Element {
  return (
    <div
      className={cn(st.Root, className)}
      data-testid={dataTestId}
    >
      <div className={st.Title}>
        {title}
      </div>

      {!!actions && (
        <div className={st.Actions}>
          {actions}
        </div>
      )}
    </div>
  );
}
